import { getApiToken } from "./apiToken";

// Envoltura de fetch que agrega "Authorization: Bearer <token>" cuando hay
// una sesión activa. Los endpoints protegidos del backend la exigen.
export function authFetch(url, options = {}) {
  const token = getApiToken();
  const headers = { ...(options.headers || {}) };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(url, { ...options, headers });
}
